<!--  -->
@if (notStarted()) {
  <ism-svg [name]="'xCircle'" [classString]="'iBTTiny:w-7 iBTTiny:h-7 lanPixel2xl:w-8 lanPixel2xl:h-8 flex items-center text-red-600'"></ism-svg>
}
<!--  -->
@if (complete()) {
  <ism-svg [name]="'checkCircle'" [classString]="'iBTTiny:w-7 iBTTiny:h-7 lanPixel2xl:w-8 lanPixel2xl:h-8 flex items-center text-green-600'"></ism-svg>
}
<!--  -->
@if (incomplete()) {
  <ism-svg [name]="'hamburger'" [classString]="'iBTTiny:w-7 iBTTiny:h-7 lanPixel2xl:w-8 lanPixel2xl:h-8 flex items-center text-yellow-600'"></ism-svg>
}
